import ReactDOM from 'react-dom';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import App from './componentes/App';
import './index.css';
ReactDOM.render( <App/> ,  document.getElementById('root')
);
